import TagList from './tagList'

export default TagList
